var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"Feed"},[(_vm.feed.item_type==="post")?_c('Post',{attrs:{"post":_vm.feed},on:{"update":function($event){return _vm.$emit("update")},"delete":function($event){return _vm.$emit("delete")},"comment-delete":_vm.handleCommentDelete}}):_c('Notification',{attrs:{"notification":_vm.feed,"contactTypes":_vm.contactTypes}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }